import {BaseRectangle} from './BaseRectangle';

const DEFAULT_OPTIONS = {
  fill: '#fff',
  opacity: 1
};

/**
 * This fills a rectangle-shaped area on a canvas.
 */
export class SolidRectangle extends BaseRectangle {
  constructor (x, y, w, h, options = {}) {
    super(x, y, w, h, Object.assign({}, DEFAULT_OPTIONS, options));
  }

  paint (ctx, x, y, w, h) {
    ctx.globalAlpha = this._options.opacity;
    ctx.clearRect(x, y, w, h);
    ctx.fillStyle = this._options.fill;
    ctx.fillRect(x, y, w, h);
  }

  get fill () {
    return this._options.fill;
  }
  set fill (value) {
    this._options.fill = value;
  }

  get opacity () {
    return this._options.opacity;
  }
  set opacity (value) {
    this._options.opacity = value;
  }
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/snapshot/drawing/shapes/SolidRectangle.js